import { CreditCardOutlined, FileTextOutlined, OrderedListOutlined, WalletOutlined } from '@ant-design/icons';
import React from 'react';

export default {
    path: '/billing-management',
    code: 'BillingManagement',
    name: '账务管理',
    routes: [
      {
        path: '/billing-management',
        hideInMenu: true,
        component: './MenuRedirect',
      },
      {
        path: '/billing-management/account-balance',
        code: 'BillingManagement-AccountBalance',
        name: '账户流水',
        icon: <WalletOutlined />,
        routes: [
          {
            path: '/billing-management/account-balance',
            hideInMenu: true,
            component: './BillingManagement/AccountBalance',
          },
          {
            path: '/billing-management/account-balance/recharge',
            code: 'BillingManagement-AccountRecharge-Button',
            name: '账户充值',
            hideInMenu: true,
            component: './BillingManagement/AccountRecharge',
          },
        ],
      },
      {
        path: '/billing-management/recharge-record',
        code: 'BillingManagement-RechargeRecord',
        name: '充值记录',
        icon: <CreditCardOutlined />,
        component: './BillingManagement/RechargeRecord',
      },
      {
        path: '/billing-management/order-list',
        code: 'BillingManagement-OrderList',
        name: '订单',
        icon: <OrderedListOutlined />,
        component: './BillingManagement/OrderList',
      },
      {
        path: '/billing-management/bill',
        code: 'BillingManagement-Bill',
        name: '账单',
        icon: <FileTextOutlined />,
        component: './BillingManagement/Bill',
      },
    ],
  };
